import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaCog, FaHeadset } from 'react-icons/fa';

const WhyChooseSection = () => {
  const features = [
    {
      icon: FaCheckCircle,
      title: "Quality Assurance",
      description: "All our products meet international safety standards and undergo rigorous quality testing",
      bgColor: "bg-blue-50",
      iconColor: "text-catalina-blue"
    },
    {
      icon: FaCog,
      title: "Expert Installation",
      description: "Professional installation and maintenance services by certified technicians",
      bgColor: "bg-green-50",
      iconColor: "text-green-600"
    },
    {
      icon: FaHeadset,
      title: "24/7 Support",
      description: "Round-the-clock customer support and emergency service availability",
      bgColor: "bg-orange-50",
      iconColor: "text-tango"
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-catalina-blue mb-4">Why Choose TroLift?</h2>
          <p className="text-xl text-gray-600">
            We deliver excellence in every aspect of our lifting solutions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div 
                key={index} 
                className={`${feature.bgColor} p-8 rounded-lg shadow-md hover:shadow-xl transition duration-300`}
              >
                <div className={`${feature.iconColor} mb-4 flex justify-center`}>
                  <IconComponent className="w-12 h-12" />
                </div>
                <h3 className="text-2xl font-bold text-catalina-blue mb-3 text-center">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-center leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <Link
            to="/contact"
            className="bg-catalina-blue text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-catalina-blue/90 transition duration-300 inline-block shadow-lg hover:shadow-xl"
          >
            Get Started Today
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;